import { cn } from "@babybjorn/ui";
import type { ChangeEvent, FC, PropsWithChildren } from "react";
import Button from "../../../general/Button";
import SearchBar from "../../../general/SearchBar";
import * as s from "./QuickSearchModal.module.scss";

type QuickSearchModalProps = PropsWithChildren<{
	isOpen: boolean;
	closeSearch: () => void;
	searchValue: string;
	setSearchValue: (event: ChangeEvent<HTMLInputElement>) => void;
	clearSearch: () => void;
	labels: { [key: string]: string };
}>;

const QuickSearchModal: FC<QuickSearchModalProps> = ({
	isOpen,
	children,
	closeSearch,
	searchValue,
	setSearchValue,
	clearSearch,
	labels,
}) => {
	const { clearLabel, closeLabel, searchLabel, searchPlaceholder } = labels;

	return (
		<nav
			className={cn(s.quickSearch, {
				[s.isOpen]: isOpen,
				[s.hidden]: !isOpen,
			})}
		>
			<div className={s.searchBarWrapper}>
				<SearchBar
					clearCallback={clearSearch}
					clearLabel={clearLabel}
					inputLabel={searchLabel}
					searchPlaceholder={searchPlaceholder}
					onChange={(event) => setSearchValue(event)}
					value={searchValue}
					quickSearch
					quickSearchOpen={isOpen}
				/>
			</div>
			<div className={s.childrenWrapper}>
				<Button
					variant="secondary"
					buttonType="standard"
					icon="close"
					alwaysSmall
					label={closeLabel}
					iconLeft
					onClick={closeSearch}
					className={cn(s.closeButton)}
				/>
				{children}
			</div>
		</nav>
	);
};

export default QuickSearchModal;
